import { createContext, useEffect, useState } from "react";

import type { Maybe, WindowSize } from "@eroad/types";

const WindowSizeContext = createContext<Maybe<WindowSize>>(undefined);

const WindowSizeProvider = ({ children }: React.PropsWithChildren<unknown>): JSX.Element => {
  const [size, setSize] = useState<WindowSize>(getSize());

  useEffect(() => {
    function handleResize() {
      setSize(getSize());
    }

    globalThis.addEventListener("resize", handleResize);

    return () => {
      globalThis.removeEventListener("resize", handleResize);
    };
  }, []);

  return <WindowSizeContext.Provider value={size}>{children}</WindowSizeContext.Provider>;
};

/**
 * @internal
 */
function getSize(): WindowSize {
  return {
    innerHeight: globalThis.innerHeight,
    innerWidth: globalThis.innerWidth,
  };
}

export { WindowSizeContext, WindowSizeProvider };
